<template>
  <div :style="'margin-top: 150px; padding: 20px;'">
    <hr style="background-color: white; margin-bottom: 20px;">
    <div style="text-align: center; color: black;">
       &copy; 2017 - {{new Date().getFullYear()}} Raizzon Infotech LLP
    </div>
  </div>
</template>

<script>
export default {
    computed: {
      getScreenWidth() {
        return window.screen.width
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Footer/Index.vue